/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseBigDecimal } from '../../models/api-response-big-decimal';

export interface GetTotalCost1$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function getTotalCost1(http: HttpClient, rootUrl: string, params: GetTotalCost1$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseBigDecimal>> {
  const rb = new RequestBuilder(rootUrl, getTotalCost1.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseBigDecimal>;
    })
  );
}

getTotalCost1.PATH = '/v1/api/ui/flows/cost/total';
